// @ts-nocheck
import {
  buildNormalizedAliases,
  buildColumnMap,
  buildRecordFromColumnMap,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const KYUNGBO_FIELD_ALIASES = {
  hospitalName: ['거래처명'],
  drugCode: ['보험코드'],
  drugName: ['제품명'],
  unitPrice: ['단가'],
  quantity: ['수량'],
  prescriptionAmount: ['금액'],
  feeRate: ['담당 수수료율'],
  settlementAmount: ['담당수수료 합계'],
  pharmaceuticalCompanyName: ['제조사'],
};

const REQUIRED_HEADERS = [
  '처방월',
  '정산월',
  '거래처명',
  '제조사',
  '보험코드',
  '제품명',
  '수량',
  '단가',
  '금액',
  '담당 수수료율',
  '담당수수료 합계',
];

function isKyungboProfile(profile) {
  return REQUIRED_HEADERS.every((header) =>
    profile.headers.some(
      (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
    ),
  );
}

const kyungboPharmTemplate = {
  id: 'kyungbo-pharm',
  name: '경보제약 템플릿',
  match(context) {
    return context.headerProfiles.some(isKyungboProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isKyungboProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[targetProfile.headerRowIndex] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(KYUNGBO_FIELD_ALIASES),
    );
    const extractedRows = [];

    rows.slice(targetProfile.headerRowIndex + 1).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const insuranceCode = cleanText(row[columnMap.drugCode]);
      if (!insuranceCode) {
        return;
      }

      const record = buildRecordFromColumnMap({
        row,
        columnMap,
        fileName: context.file.name,
        sheetName,
        rowIndex: targetProfile.headerRowIndex + rowOffset + 1,
        templateId: this.id,
        detectedPharmaceuticalCompany: cleanText(
          row[columnMap.pharmaceuticalCompanyName],
        ),
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: '경보제약',
      templateName: this.name,
    };
  },
};

export default kyungboPharmTemplate;
